<template>
  <div v-if="isOpen">
    <div class="modal fade" role="dialog" ref="TokenizationLinkModal">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body tokenization-link-modal">
            <div class="copy-toast" :class="{ show: isCopy }">
              Link copied to clipboard
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex justify-between items-center">
                  <h4 style="font-weight: 800">Tokenization Link</h4>
                  <button
                    type="button"
                    class="close btn-close-modal"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal()"
                  >
                    <i class="ic-close"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-12 mt-20 mb-20">
                <div class="d-flex justify-between">
                  <div class="link-box">
                    <a :href="link" target="_blank" class="link-text">{{
                      link
                    }}</a>
                  </div>
                  <button
                    type="button"
                    class="btn btn-copy"
                    title="Click to copy"
                    @click="handleCopy"
                  >
                    <transition name="icon-fade" mode="out-in">
                      <svg
                        v-if="!isCopy"
                        key="copy"
                        class="icon"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
                          fill="currentColor"
                        ></path>
                      </svg>
                      <svg
                        v-else
                        key="check"
                        class="icon"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M5 12l5 5L20 7"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                    </transition>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isOpen: false,
      isCopy: false,
      msg: "Please wait",
      link: "https://payment-dev.idteknologia.net/token/ClQiXnpcnzmFcNnBpIbPZ7jNedsylEKsieUDpgRFs8LDV0UDVzk0q7SkaxJfN14LevXCM5HWENUrxl9zxnd6q4t0LhZKI7kO8ehLBC6qIpAA6WSBOSYXiCL7d4aYmiXJ6FiPtZynKoPgR21EmC4P2GbRl7kl7FwNDGGM0HTI0yk16z0TXgpVbdawwn8CXwnCnKvJfQriwo7CRF9A59VGDmWh367LXthPbjf5SKUuELrCsdTwE1CpmcfBgwS48JWdekV18KPZ2NtCojTy6UCGlbNTtl0ADgYEj",
    };
  },
  created() {
    this.$eventBus.$on("TokenizationLinkModal", this.initialize);
  },
  beforeDestroy() {
    this.$eventBus.$off("TokenizationLinkModal");
  },
  methods: {
    initialize(link) {
      this.link = link;
      this.isOpen = true;
      setTimeout(() => {
        $(this.$refs.TokenizationLinkModal).modal({
          backdrop: "static",
          keyboard: false,
        });
      }, 1000);
    },
    async handleCopy() {
      this.isCopy = true;
      await navigator.clipboard.writeText(this.link);

      setTimeout(() => {
        this.isCopy = false;
      }, 2000);
    },
    closeModal() {
      this.isOpen = false;
      $(this.$refs.TokenizationLinkModal).modal("hide");
    },
  },
};
</script>
<style scoped>
.modal-body.tokenization-link-modal {
  padding: 15px 20px;
}

.copy-toast {
  position: fixed;
  top: 35px;
  left: 50%;
  transform: translateX(-50%) translateY(-20px);
  background: transparent;
  color: #4fb848;
  padding: 12px 18px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  opacity: 0;
  visibility: hidden;
  transition: all 0.25s ease;
  z-index: 9999;
}

.copy-toast.show {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.link-box {
  width: 90%;
  padding: 10px;
  /* border: 1px solid #363636; */
  background: rgba(79, 184, 72, 0.2);
  border-radius: 4px;
}

.link-box a.link-text {
  width: 100%;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* color: #363636; */
  color: #4fb848;
}

.btn.btn-copy {
  background: transparent;
  border: 1px solid #4fb848;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn.btn-copy svg {
  color: #4fb848;
}

.icon {
  width: 20px;
  height: 20px;
}

/* ENTER */
.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: all 0.2s ease;
}

/* MASUK */
.icon-fade-enter-from {
  opacity: 0;
  transform: scale(0.6) rotate(-90deg);
}

/* KELUAR */
.icon-fade-leave-to {
  opacity: 0;
  transform: scale(0.6) rotate(90deg);
}
</style>



// WEBPACK FOOTER //
// src/components/shared/TokenizationLinkModal.vue